export function isOverlayKeepOpenTarget(target: EventTarget | null): boolean {
  return target instanceof Element && Boolean(target.closest('[data-overlay-keep-open]'))
}
